"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoCompleteMenu = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const mithril_1 = require("../../mithril");
const highlighter_1 = require("../../services/util/highlighter");
const menu_1 = require("../menu/menu");
const menu_item_1 = require("../menu/menu.item");
const mithril_component_1 = require("../mithril.component");
const theme_1 = require("../theme");
const autocomplete_menu_style_1 = require("./autocomplete.menu.style");
(0, theme_1.addStyles)(autocomplete_menu_style_1.Styles);
const DEFAULT_MAX_RESULTS = 5;
const emptyStr = str => str == null || str.trim() === '';
class AutoCompleteMenu extends mithril_component_1.IMithrilComponent {
    constructor(ctx) {
        super();
        this.ctx = ctx;
        this.menu = new menu_1.MenuComponent({
            items: () => this.items,
            open: () => this.canOpen(),
            className: autocomplete_menu_style_1.CSS.container
        });
    }
    get nodes() {
        return this.menu.view();
    }
    canOpen() {
        return this.ctx.inputState.focused && this.items.length > 0;
    }
    isOpen() {
        return this.menu.isOpen;
    }
    get items() {
        const { inputState, maxResults = DEFAULT_MAX_RESULTS } = this.ctx;
        const items = this.ctx.options();
        if (emptyStr(inputState.value)) {
            return items
                .slice(0, maxResults)
                .map(val => this.createMenuItem([{ highlighted: false, content: val.value }], val));
        }
        let hasMatch = false;
        const highlighted = [];
        for (const item of items) {
            const match = highlighter_1.Highlighter.highlight(item.value, inputState.value);
            if (match.parts.length > 1) {
                highlighted.push({ match, item });
            }
            else if (match.parts.length === 1 && match.parts[0].highlighted === true) {
                // If there is only one part it may fully match the input string
                highlighted.push({ match, item });
                hasMatch = true;
            }
        }
        const options = highlighted
            .sort((a, b) => b.match.score - a.match.score)
            .slice(0, maxResults)
            .map(val => this.createMenuItem(val.match.parts, val.item));
        if (this.ctx.showNew && hasMatch === false) {
            const node = this.createMenuItem([
                { highlighted: true, content: inputState.value },
                { highlighted: false, content: ' ( new )' }
            ], { id: null, value: inputState.value });
            options.push(node);
        }
        return options;
    }
    createMenuItem(parts, option) {
        const text = parts.map(part => (0, mithril_1.m)('span', { className: part.highlighted ? autocomplete_menu_style_1.CSS.highlighted : '' }, part.content));
        if (this.ctx.optionView != null) {
            return this.ctx.optionView(option, text);
        }
        return {
            view: menu_item_1.MenuItemComponent.view(text),
            action: () => this.ctx.onselect(option)
        };
    }
}
exports.AutoCompleteMenu = AutoCompleteMenu;
tslib_1.__decorate([
    mobx_1.computed
], AutoCompleteMenu.prototype, "items", null);
//# sourceMappingURL=autocomplete.menu.js.map